import { render, staticRenderFns } from "./config-template.vue?vue&type=template&id=19b8d926"
import script from "./config-template.vue?vue&type=script&lang=js"
export * from "./config-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports